import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './store'
import { zoomSdkApi } from './zoomSdkQueries'

type Role = 'host' | 'coHost' | 'attendee' | 'panelist' | 'participant'
type NewRole = 'host' | 'participant' | undefined
type User = {
  role?: Role
  screenName?: string
  newRole?: NewRole
}
const initialState: User = {}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    changeRole: (state, { payload }: PayloadAction<Role>) => {
      state.role = payload
    },
    setRoleChange: (state, { payload }: PayloadAction<NewRole>) => {
      state.newRole = payload
    },
  },
  // allows values to be initial state for the user reducer
  extraReducers: (builder) => {
    builder.addMatcher(
      zoomSdkApi.endpoints.getUserContext.matchFulfilled,
      (state, { payload: { role, screenName } }) => {
        state.screenName = screenName
        state.role = role as Role
      }
    )
  },
})

export const { changeRole, setRoleChange } = userSlice.actions

export const selectUserRole = (state: RootState) => state.user.role
export const selectUserScreenName = (state: RootState) => state.user.screenName
export const selectNewUserRole = (state: RootState) => state.user.newRole

export default userSlice
